/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateModalityCheckoutSessionDto
 */
export interface CreateModalityCheckoutSessionDto {
    /**
     * Number of modality slots to purchase
     * @type {number}
     * @memberof CreateModalityCheckoutSessionDto
     */
    quantity: number;
}

/**
 * Check if a given object implements the CreateModalityCheckoutSessionDto interface.
 */
export function instanceOfCreateModalityCheckoutSessionDto(value: object): value is CreateModalityCheckoutSessionDto {
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function CreateModalityCheckoutSessionDtoFromJSON(json: any): CreateModalityCheckoutSessionDto {
    return CreateModalityCheckoutSessionDtoFromJSONTyped(json, false);
}

export function CreateModalityCheckoutSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateModalityCheckoutSessionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
    };
}

export function CreateModalityCheckoutSessionDtoToJSON(json: any): CreateModalityCheckoutSessionDto {
    return CreateModalityCheckoutSessionDtoToJSONTyped(json, false);
}

export function CreateModalityCheckoutSessionDtoToJSONTyped(value?: CreateModalityCheckoutSessionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quantity': value['quantity'],
    };
}

